var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-container"},[_c('canvas',{ref:"chart",staticClass:"line-chart",attrs:{"height":"700"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }